// TODO replace all usage with createReducer from typesafe-actions
export default function simpleReducer(initialState, reducers) {
  // biome-ignore lint/style/useDefaultParameterLast: ignore
  return (state = initialState, action, prevState) => {
    return reducers[action.type] ? reducers[action.type](state, action, prevState) : state;
  };
}
